<template>
  <div class="detail" v-if="detail">
    <div class="content">
      <ListItem :data="detail" origin="detail"></ListItem>
    </div>
  </div>
</template>

<script>

import CONFIG from '@/utils/config'
import COVERAPP from '@/utils/COVERAPP'
import COVER from '@/utils/COVER'
import ListItem from '@/components/ListItem.vue'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'home',
  data() {
    return {
			detail: null
    }
  },
  components: {
		ListItem
	},
	computed: {
    ...mapState(['shareData'])
	},
	mounted() {
		this.share()
		document.querySelector('.loading-wrap').style.display = 'none'	
    this.setPageLoadingAsync(false)
    const id = this.$route.params.id || '';
    if (id) {
      this.getDetail(id);
    } else {
      this.$router.push('/');
    }
	},
  methods: {
		...mapActions([
			'setPageLoadingAsync'
    ]),
		share() {
			COVER.share(this.shareData)		
    },
    getDetail(vid) {
      this.$request(`/vote/${vid}`, "get").then(res => {
        if (res.errno === 0) {
          this.detail = res.data;
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
  .detail {
    background: #2B4AA7;
    width: 100vw;
    min-height: 100vh;
  }
</style>